module.exports = __webpack_public_path__ + "img/Bodice-Front-B8-Da-Eb.e18b1349.png";